import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Balls of Fire (native Incisor port, real wallet via /api/bof/v2).
export default function BofRoute() {
    const navigate = useNavigate();
    const frame = useRef(null);
    useEffect(() => {
        function receive(e) {
            if (e.origin !== window.location.origin || e.source !== frame.current?.contentWindow) return;
            if (e.data?.type === 'bof:exit') navigate('/casino/slots');
        }
        window.addEventListener('message', receive);
        return () => window.removeEventListener('message', receive);
    }, [navigate]);
    return (
        <iframe ref={frame} data-testid="bof-game-frame" src="/games/bof/index.html?v=6" title="Balls of Fire" allow="autoplay; fullscreen" allowFullScreen
            style={{ position: 'fixed', inset: 0, width: '100%', height: '100dvh', border: 0, background: '#0b0503', zIndex: 60 }} />
    );
}
